// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fhKsviWooUapaKq1Sd6Cd","table-wrapper":"_1z2QaxV2hxvwAi9-uxywsI"};